import Vue from 'vue'
import formComment from '@components/ui-components/form-comment/form-comment'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import LoadMore from '@components/ui-components/load-more/load-more'
import Banner from '@components/ui-components/banner/component.js'
import Quote from '@components/ui-components/builder/quote/component.js'
import SliderView from '@components/ui-components/slider-view/component.js'
import tagsBlock from '@components/ui-components/tags/tags.vue'
import onScrollAnimate from '@assets/js/scrollAnimate.js'
import { router } from '@src/routes'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      optionSliderView: {
        spaceBetween: 24,
        loop: true,
        cursor: 'grab',
        speed: 500,
        navigation: {
          nextEl: '.js-slider-next',
          prevEl: '.js-slider-prev',
        },
      },
      newComments: [],
      pagination: null,
      disableLoadMore: false,
    }
  },
  components: {
    'form-comment-cmp': formComment,
    'load-more-cmp': LoadMore,
    'banner-cmp': Banner,
    'builder-quote': Quote,
    'slider-view-cmp': SliderView,
    'tags-cmp': tagsBlock,
  },
  methods: {
    setPagination() {
      setTimeout(() => {
        this.pagination = this.$root.convertTwigToJs('pagination', '.js-pagination-blog-view')
      }, 100)
    },
    getName(name) {
      let mass = name.split(' ')
      mass = mass.filter((item, index) => index < 2)
      let result = ''
      mass.forEach(item => {
        result = result + item.split('')[0]
      })
      return result
    },
  },
  mounted() {
    this.setPagination()
  },
  beforeRouteUpdate(to, from, next) {
    // если не loadMore
    if (!to.query.loadMore) {
      const path = to.path.replace(router.history.base, '')
      this.$root.setDataAnimateFalse()

      Vue.http.get(`templates${path}`, { params: to.query }).then(
        data => {
          next()
          // this.$root.setDataAnimateTrue();
          setTimeout(() => {
            this.template = data.data
            this.setPagination()
            this.newComments = []
          }, 100)
        },
        () => {
          next('/404')
        }
      )
    } else {
      this.disableLoadMore = true
      let url = process.env.NODE_ENV !== 'production' ? 'comments/index.json' : 'blog/comment/more'

      Vue.http.get(url, { params: to.query }).then(
        data => {
          next()
          this.newComments = this.newComments.concat(data.data.items)
          this.pagination = data.data.pagination
          this.disableLoadMore = false
          setTimeout(() => {
            onScrollAnimate()
          }, 10)
        },
        () => {
          this.disableLoadMore = false
          next('/404')
        }
      )
    }
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/blog/view/index.js